/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { USERROLES } from '../../../app.config';
import { LocalCacheService } from '../../../core/local-cache/local-cache.service';
// import { AppEnvConfig } from '../../../app.config';
// import { UserService } from '../../../../user.service';
import { SSDWidgetServiceConstants } from '../../../ssd-widgets/_enum/service-constants';
import { ChatContent, ChatResponse } from '../models/chat.model';
import { AIAgentServiceConfig } from './ai-agent.service.config';
import { UserService } from '../../../core/user/user.service';
import { AppEnvConfig } from '../../../app.env.config';
// import { AppEnvConfig } from '../../../app.env.config';
@Injectable({
    providedIn: 'root'
})
export class AIAgentService {
    private conversationId$ = new BehaviorSubject<string>('');
    public isFsqsMode$ = new BehaviorSubject<boolean>(false);
    private sessionId: string;
    private apiUrl = ''; // OpenAI API URL
    private apiKey = ''; // Replace with your OpenAI API key
    private configEnv: any;

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private httpClient: HttpClient,
        private config: AppEnvConfig,
        private aiAgentServiceConfig: AIAgentServiceConfig,
        private localCacheService: LocalCacheService
    ) {
        this.sessionId = this.generateSessionId();
        this.configEnv = this.aiAgentServiceConfig.getEnvironment();
        this.configEnv.apiWaterServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_WATER_SERVER_URL);
        this.configEnv.apiPlatformServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_SERVER_URL);
        this.configEnv.apiProcedureSchedulingServiceUrl = config.getEnv('apiProcedureSchedulingServiceUrl');
    }

   
    /**
     * Start a new conversation
     */
    startNewConversation(): void {
        this.conversationId$.next('');
        this.sessionId = this.generateSessionId();
    }

    /**
     * Get current conversation ID
     */
    getCurrentConversationId(): Observable<string> {
        return this.conversationId$.asObservable();
    }

    /**
     * Send feedback for a chat response
     */
    sendFeedback(messageId: string, isHelpful: boolean, feedback?: string): Observable<void> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.apiKey}`
        });

        const body = {
            messageId,
            isHelpful,
            feedback: feedback?.trim(),
            sessionId: this.sessionId
        };

        return this.http.post<void>(`${this.apiUrl}/feedback`, body, { headers })
            .pipe(
                catchError(error => {
                    console.warn('Failed to send feedback:', error);
                    return of(void 0); // Fail silently for feedback
                })
            );
    }

    /**
     * Check if chat service is available
     */
    checkServiceHealth(): Observable<boolean> {
        return this.http.get(`${this.apiUrl}/health`)
            .pipe(
                map(() => true),
                catchError(() => of(false))
            );
    }

    private generateSessionId(): string {
        return 'session_' + Math.random().toString(36).substring(2, 15) +
            '_' + Date.now().toString(36);
    }


 

    sendMessage(message: string, contextPointId: number, chatId: string): Observable<any> {
        const url = this.parse(this.configEnv.apiWaterServerUrl + this.configEnv.apiUrl.message);
        const payload = { "Message": message, "ConversationContext": '', "SiteId": contextPointId, "ChatId": chatId? chatId : '' };
        return this.httpClient.post<any>(url, payload).pipe(map(response => {
            try {
                return response;
            } catch (e) {
                return response;
            }
        }));
    }

    private parse(url: string, params: string[] = []): string {
        let result: string = url;
        if (params.length > 0) {
            result = url.replace(/\{(\d+)\}/g, function (match: string, current: string): string {
                return params[parseInt(current, 10)] !== undefined ? params[parseInt(current, 10)] : '';
            });
        }
        return result;
    }

     /**
     * Get conversation history list
     */
    getConversationHistoryList(): Observable<any> {
        const userID = this.userService.getCurrentSettings().UserId;
        const url = this.parse(this.configEnv.apiWaterServerUrl + this.configEnv.apiUrl.historyList);

        return this.http.get<any>(`${url}?userId=${userID}`).pipe(
            map(response => response || []),
            catchError(error => {
                return error;
            })
        );
    }

    getChatHistory(id:string): Observable<any> {
        const userID = this.userService.getCurrentSettings().UserId;
        const url = this.parse(this.configEnv.apiWaterServerUrl + this.configEnv.apiUrl.getChatHistory);

        return this.http.get<any>(`${url}?userId=${userID}&chatId=${id}`).pipe(
            map(response => response || []),
            catchError(error => {
                return error;
            })
        );
    }

    public getsitesByCorporate(corporateIds: Array<number>): Observable<any> {
    const url = this.configEnv.apiPlatformServerUrl + this.configEnv.apiUrl.getSitesForCorporates;
    const body = JSON.stringify(corporateIds);
    return this.httpClient.post(url, body).pipe(map(response => {
      try {
        return response;
      } catch (e) {
        return response;
      }
    }));
  }

  setFsqsMode(value: boolean): void {
        this.isFsqsMode$.next(value);
    }

    sendFsqsMessage(message: string, chatId: string): Observable<any> {
        let contextPointIds: number[] = [];
        const isEnterpriseDashboard = window.location.href.includes(`/food-safety-iq/enterprise-dashboard`);

        if (isEnterpriseDashboard) {
            const selectedSiteRaw = localStorage.getItem("fsqs_corporate_dropdown_selection");
            const selectedSites = selectedSiteRaw
                ? JSON.parse(selectedSiteRaw)
                : null;
            contextPointIds =
                selectedSites?.sites
                ?.filter((site: any) => site.selected)
                .map((site: any) => site.contextPointId) || [];
        } else {
            const fsqsSiteRaw = this.localCacheService.fetchData(
                "fsqsSelectedSite",
                "local",
            );
            const fsqsSite =
                fsqsSiteRaw && fsqsSiteRaw !== "undefined"
                ? JSON.parse(fsqsSiteRaw)
                : null;
            if (fsqsSite?.ContextPointId) {
                contextPointIds = [fsqsSite.ContextPointId];
            }
        }

        const settings = this.userService.getCurrentSettings();
        const userId = settings?.UserId || 0;
        const personaCode = 'sanitation_manager';

       const url = `${this.configEnv.apiProcedureSchedulingServiceUrl}${this.configEnv.apiUrl.EvaGenAIResponse}?mock=true`;

        const payload = {
            messages: [{ role: 'user', content: message }],
            chat_id: chatId || '',
            context_point_ids: contextPointIds,
            context_point_id_type: 5000,
            persona_code: personaCode,
            user_id: userId
        };

        return this.httpClient.post<any>(url, payload);
    }

}